import angular from "angular";

angular.module('ui-sentinel.sentinel', []);
